import type { IReferenceDesign } from '@/models/reference_design'
import { ReferenceDesign } from '@/models/reference_design'
import referenceDesignService from '@/services/reference_design/reference-design'
import { defineStore } from 'pinia'
import type { IReferenceDesignState } from './reference-design.types'

export const useReferenceDesignStore = defineStore('referenceDesign', {
  state: (): IReferenceDesignState => ({
    referenceDesigns: []
  }),
  
  getters: {
    getReferenceDesigns(state: IReferenceDesignState): IReferenceDesign[] {
      return state.referenceDesigns.map((referenceDesign) => new ReferenceDesign(referenceDesign))
    }
  },

  actions: {
    async fetchReferenceDesigns() {
      const referenceDesigns = await referenceDesignService.fetchReferenceDesigns()
      this.referenceDesigns = referenceDesigns
    }
  }
})
